// 事件发布订阅管理
import { createContext, useContext } from "use-context-selector";
import { useEventEmitter } from "ahooks";

const EventEmitterContext = createContext({
  eventEmitter: null,
});

export const useEventEmitterContext = () => useContext(EventEmitterContext);

export const EventEmitterContextProvider = ({
  children,
}) => {
  const eventEmitter = useEventEmitter();

  return (
    <EventEmitterContext.Provider value={{ eventEmitter }}>
      {children}
    </EventEmitterContext.Provider>
  );
};

export default EventEmitterContext;

export const EventEmitterType = {
  AgentSave: "agentSave",
  DashboardSelectMenu: "dashboardSelectMenu",
};

export const AgentSaveType = {
  ALL: "all",
  WorkFlow: "WorkFlow",
  AgentSetting: "AgentSetting",
};
